var _defs, _path, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _text92, _path57;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "595pt",
    height: "842pt",
    viewBox: "0 0 595 842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M443.28 773.722H543.24V780.32199H443.28Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M37.68 62.602H543.24V806.722H37.68Z",
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -774.1751,
    x: "443.50163 451.18547 458.8693 466.55314 474.23695 481.92079 489.6046 497.28846 504.9723 512.6561 520.33999 528.0238 535.7077"
  }, "&#xff08;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#x3000;&#xff09;")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0005 0 842)",
    fontSize: 9.404698,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -797.4433,
    x: 545.7927
  }, "&#x5225;"), /*#__PURE__*/React.createElement("tspan", {
    y: -786.898,
    x: 545.7927
  }, "&#x8868;"), /*#__PURE__*/React.createElement("tspan", {
    y: -776.3527,
    x: 545.7927
  }, "&#x5341;"), /*#__PURE__*/React.createElement("tspan", {
    y: -765.68746,
    x: 545.7927
  }, "&#x516d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -755.14218,
    x: 545.7927
  }, "&#x3225;"), /*#__PURE__*/React.createElement("tspan", {
    y: -744.5969,
    x: 545.7927
  }, "&#x3000;"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0005 0 842)",
    fontSize: 9.404698,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -734.05166,
    x: 545.7927
  }, "&#x4ee4;"), /*#__PURE__*/React.createElement("tspan", {
    y: -723.50637,
    x: 545.7927
  }, "&#x56db;"), /*#__PURE__*/React.createElement("tspan", {
    y: -712.9611,
    x: 545.7927
  }, "&#x30fb;"), /*#__PURE__*/React.createElement("tspan", {
    y: -702.2958,
    x: 545.7927
  }, "&#x56db;"), /*#__PURE__*/React.createElement("tspan", {
    y: -691.7505,
    x: 545.7927
  }, "&#x30fb;"), /*#__PURE__*/React.createElement("tspan", {
    y: -681.20529,
    x: 545.7927
  }, "&#x4e00;"), /*#__PURE__*/React.createElement("tspan", {
    y: -670.66,
    x: 545.7927
  }, "&#x4ee5;"), /*#__PURE__*/React.createElement("tspan", {
    y: -660.11477,
    x: 545.7927
  }, "&#x5f8c;"), /*#__PURE__*/React.createElement("tspan", {
    y: -649.56948,
    x: 545.7927
  }, "&#x7d42;"), /*#__PURE__*/React.createElement("tspan", {
    y: -639.0242,
    x: 545.7927
  }, "&#x4e86;"), /*#__PURE__*/React.createElement("tspan", {
    y: -628.3589,
    x: 545.7927
  }, "&#x4e8b;"), /*#__PURE__*/React.createElement("tspan", {
    y: -617.8136,
    x: 545.7927
  }, "&#x696d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -607.2684,
    x: 545.7927
  }, "&#x5e74;"), /*#__PURE__*/React.createElement("tspan", {
    y: -596.7231,
    x: 545.7927
  }, "&#x5ea6;"), /*#__PURE__*/React.createElement("tspan", {
    y: -586.1778,
    x: 545.7927
  }, "&#x53c8;"), /*#__PURE__*/React.createElement("tspan", {
    y: -575.63259,
    x: 545.7927
  }, "&#x306f;"), /*#__PURE__*/React.createElement("tspan", {
    y: -564.9672,
    x: 545.7927
  }, "&#x9023;"), /*#__PURE__*/React.createElement("tspan", {
    y: -554.42196,
    x: 545.7927
  }, "&#x7d50;"), /*#__PURE__*/React.createElement("tspan", {
    y: -543.8767,
    x: 545.7927
  }, "&#x4e8b;"), /*#__PURE__*/React.createElement("tspan", {
    y: -533.3314,
    x: 545.7927
  }, "&#x696d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -522.7862,
    x: 545.7927
  }, "&#x5e74;"), /*#__PURE__*/React.createElement("tspan", {
    y: -512.2409,
    x: 545.7927
  }, "&#x5ea6;"), /*#__PURE__*/React.createElement("tspan", {
    y: -501.69566,
    x: 545.7927
  }, "&#x5206;"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0005 0 842)",
    fontSize: 9.404698,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -797.4433,
    x: "45.62279 55.22759 64.83238 74.43718 84.04198 93.646778 103.25157 112.85637 122.46117 132.06597 141.67078 151.27558 160.88037 170.48519 180.08998 189.6948 199.29959 208.90436"
  }, "&#x7e70;&#x5ef6;&#x8cc7;&#x7523;&#x306e;&#x511f;&#x5374;&#x984d;&#x306e;&#x8a08;&#x7b97;&#x306b;&#x95a2;&#x3059;&#x308b;&#x660e;&#x7d30;&#x66f8;"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0005 0 842)",
    fontSize: 8.504249,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -787.0085,
    x: "413.24647 421.8908 430.5351"
  }, "&#x6cd5;&#x4eba;&#x540d;"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -233.36536,
    x: "45.38268 53.546758 61.71084 69.75486 77.918949 85.96296 94.12704 102.17106 110.33514 118.37916 126.54323 134.58725 142.75133 150.79534 158.95943 167.00344 175.16753 183.21154"
  }, "&#x9069;&#x683c;&#x7d44;&#x7e54;&#x518d;&#x7de8;&#x6210;&#x306b;&#x3088;&#x308a;&#x5f15;&#x304d;&#x7d99;&#x3050;&#x3079;&#x304d;&#x5408;&#x4f75;"), /*#__PURE__*/React.createElement("tspan", {
    y: -224.72968,
    x: "45.38268 53.546758 61.71084 69.75486 77.918949 85.96296 94.12704 102.17106"
  }, "&#x7b49;&#x7279;&#x5225;&#x511f;&#x5374;&#x4e0d;&#x8db3;&#x984d;"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -224.72968,
    x: "110.21508 118.379169 126.54324 134.58727 142.75135 150.79535 158.95944 167.00345 175.16754 183.21155"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;"), /*#__PURE__*/React.createElement("tspan", {
    y: -216.094,
    x: "45.38268 53.78688"
  }, "&#x25cf;&#x25cf;"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -216.094,
    x: "62.191083 66.033 69.874919 73.71683 77.55776 82.12004 90.52424 94.36616 98.20708 102.769359 111.17356 119.57776 127.981967 136.38617 144.79036 153.19455 161.71881 170.123"
  }, "((12)&#x3068;(8)&#x306e;&#x3046;&#x3061;&#x5c11;&#x306a;&#x3044;&#x91d1;&#x984d;)"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -216.094,
    x: "174.68529 183.20955"
  }, "&#x25cf;&#x25cf;"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -281.7012,
    x: 68.194087
  }, "&#x8d8a;"), /*#__PURE__*/React.createElement("tspan", {
    y: -273.0729,
    x: 68.194087
  }, "&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -264.44459,
    x: 68.194087
  }, "&#x306e;"), /*#__PURE__*/React.createElement("tspan", {
    y: -255.81627,
    x: 68.194087
  }, "&#x5185;"), /*#__PURE__*/React.createElement("tspan", {
    y: -247.06789,
    x: 68.194087
  }, "&#x8a33;"), /*#__PURE__*/React.createElement("tspan", {
    y: -281.7012,
    x: 59.54976
  }, "&#x7fcc;"), /*#__PURE__*/React.createElement("tspan", {
    y: -273.0729,
    x: 59.54976
  }, "&#x671f;"), /*#__PURE__*/React.createElement("tspan", {
    y: -264.44459,
    x: 59.54976
  }, "&#x3078;"), /*#__PURE__*/React.createElement("tspan", {
    y: -255.81627,
    x: 59.54976
  }, "&#x306e;"), /*#__PURE__*/React.createElement("tspan", {
    y: -247.06789,
    x: 59.54976
  }, "&#x7e70;"), /*#__PURE__*/React.createElement("tspan", {
    y: -252.43584,
    x: "78.99947 99.888919 120.77835 141.54773 162.43717 183.20655"
  }, "&#x5f53;&#x671f;&#x5206;&#x4e0d;&#x8db3;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -280.5018,
    x: 117.65879
  }, "&#x30fb;"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -280.5018,
    x: "125.34164 133.02446 136.86539"
  }, "&#x25cf; &#x25cf;"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -280.5018,
    x: 144.54824
  }, "&#x30fb;"), /*#__PURE__*/React.createElement("tspan", {
    y: -271.86616,
    x: 117.65879
  }, "&#x30fb;"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271.86616,
    x: "125.34164 133.02446 136.86539"
  }, "&#x25cf; &#x25cf;"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271.86616,
    x: 144.54824
  }, "&#x30fb;"), /*#__PURE__*/React.createElement("tspan", {
    y: -421.31144,
    x: 47.06352
  }, "&#x511f;"), /*#__PURE__*/React.createElement("tspan", {
    y: -408.12886,
    x: 47.06352
  }, "&#x5374;"), /*#__PURE__*/React.createElement("tspan", {
    y: -394.8272,
    x: 47.06352
  }, "&#x8d85;"), /*#__PURE__*/React.createElement("tspan", {
    y: -381.64463,
    x: 47.06352
  }, "&#x904e;"), /*#__PURE__*/React.createElement("tspan", {
    y: -368.46205,
    x: 47.06352
  }, "&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -347.48954,
    x: 47.06352
  }, "&#x7279;"), /*#__PURE__*/React.createElement("tspan", {
    y: -331.79069,
    x: 47.06352
  }, "&#x5225;"), /*#__PURE__*/React.createElement("tspan", {
    y: -315.8517,
    x: 47.06352
  }, "&#x511f;"), /*#__PURE__*/React.createElement("tspan", {
    y: -300.0328,
    x: 47.06352
  }, "&#x5374;"), /*#__PURE__*/React.createElement("tspan", {
    y: -284.2139,
    x: 47.06352
  }, "&#x4e0d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -268.395,
    x: 47.06352
  }, "&#x8db3;"), /*#__PURE__*/React.createElement("tspan", {
    y: -252.45604,
    x: 47.06352
  }, "&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -327.99806,
    x: "58.829397 66.63329 74.4372 82.241107 90.045009 97.84891 105.65281 113.45671 121.26061 129.06452 136.74735 144.55126 152.2341 160.038 167.72084 175.52474 183.20758"
  }, "&#x5f53;&#x671f;&#x306b;&#x304a;&#x3044;&#x3066;&#x5207;&#x308a;&#x6368;&#x3066;&#x308b;&#x7279;&#x5225;&#x511f;&#x5374;&#x4e0d;&#x8db3;"), /*#__PURE__*/React.createElement("tspan", {
    y: -319.3624,
    x: "58.829397 67.71284 76.596279 85.47971 94.36315 103.24658 112.13002 121.01346 129.8969 138.78034 147.66378 156.54721 165.43065"
  }, "&#x984d;&#x53c8;&#x306f;&#x5408;&#x4f75;&#x7b49;&#x7279;&#x5225;&#x511f;&#x5374;&#x4e0d;&#x8db3;&#x984d;"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -319.3624,
    x: "174.31409 183.19753"
  }, "&#x25cf;&#x25cf;"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -323.68025,
    x: "194.97743 198.81836"
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    y: -584.90969,
    x: "58.829397 71.315639 83.80187 96.28811 108.65329 121.13953 133.5047 145.99094 158.35611 170.84235 183.20752"
  }, "&#x79df;&#x7a0e;&#x7279;&#x5225;&#x63aa;&#x7f6e;&#x6cd5;&#x9069;&#x7528;&#x6761;&#x9805;"), /*#__PURE__*/React.createElement("tspan", {
    y: -618.9726,
    x: 47.06352
  }, "&#x5f53;"), /*#__PURE__*/React.createElement("tspan", {
    y: -605.5509,
    x: 47.06352
  }, "&#x671f;"), /*#__PURE__*/React.createElement("tspan", {
    y: -592.00918,
    x: 47.06352
  }, "&#x5206;"), /*#__PURE__*/React.createElement("tspan", {
    y: -578.58749,
    x: 47.06352
  }, "&#x306e;"), /*#__PURE__*/React.createElement("tspan", {
    y: -565.1658,
    x: 47.06352
  }, "&#x511f;"), /*#__PURE__*/React.createElement("tspan", {
    y: -551.7441,
    x: 47.06352
  }, "&#x5374;"), /*#__PURE__*/React.createElement("tspan", {
    y: -538.3224,
    x: 47.06352
  }, "&#x9650;"), /*#__PURE__*/React.createElement("tspan", {
    y: -524.78067,
    x: 47.06352
  }, "&#x5ea6;"), /*#__PURE__*/React.createElement("tspan", {
    y: -511.23887,
    x: 47.06352
  }, "&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -623.65029,
    x: "58.829397 71.315639 83.80187 96.28811 108.65329 121.13953 133.5047 145.99094 158.35611 170.84235 183.20752"
  }, "&#x5f53;&#x671f;&#x5206;&#x306e;&#x666e;&#x901a;&#x511f;&#x5374;&#x9650;&#x5ea6;&#x984d;"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -606.37899,
    x: "58.829397 67.11354 75.397678 83.80188 92.08601 100.49022"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -606.37899,
    x: "108.77436 112.61627 116.4572 121.01948"
  }, "(3)&#x00d7;"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -606.37899,
    x: "129.30362 133.14553 136.98645 141.54874 149.83287 158.23706 166.5212 174.9254 183.20954"
  }, "(3)&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -489.9171,
    x: "45.38268 79.8399 114.29712 148.75435 183.21157"
  }, "&#x5f53;&#x671f;&#x511f;&#x5374;&#x984d;"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -519.0626,
    x: "58.829397 62.67032 67.47272 76.2361 84.880428"
  }, "aa&#x25cf;&#x25cf;&#x25cf;"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -519.0626,
    x: "93.52474 148.39217"
  }, "&#x5408;&#x8a08;"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -519.0626,
    x: "157.03649 165.79987 174.56325 183.20757 187.0485"
  }, "&#x25cf;&#x25cf;&#x25cf;aa"), /*#__PURE__*/React.createElement("tspan", {
    y: -508.26799,
    x: "58.829397 62.67032 66.87241 74.916439 82.96046 91.00448"
  }, "aa&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -508.26799,
    x: "99.0485 102.89041 106.73134 110.93343 118.977458 122.81937 126.66029 130.8624 138.9064 142.74832 146.58925"
  }, "(6)&#xff0b;(8)&#xff0b;(9)"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -508.26799,
    x: "150.79134 158.95543 166.99944 175.16352 183.20754 187.04846"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;aa"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -513.6653,
    x: "194.97743 198.81836"
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    y: -252.43584,
    x: "194.97743 198.81836"
  }, "21"), /*#__PURE__*/React.createElement("tspan", {
    y: -541.73129,
    x: "58.829397 66.63329 74.4372 82.241107 90.045009 97.84891 105.65281 113.45671 121.26061 129.06452 136.74735 144.55126 152.2341 160.038 167.72084 175.52474 183.20758"
  }, "&#x524d;&#x671f;&#x304b;&#x3089;&#x7e70;&#x308a;&#x8d8a;&#x3057;&#x305f;&#x7279;&#x5225;&#x511f;&#x5374;&#x4e0d;&#x8db3;&#x984d;&#x53c8;"), /*#__PURE__*/React.createElement("tspan", {
    y: -533.0956,
    x: "58.829397 67.71284 76.596279 85.47971 94.36315 103.24658 112.13002 121.01346 129.8969 138.78034 147.66378"
  }, "&#x306f;&#x5408;&#x4f75;&#x7b49;&#x7279;&#x5225;&#x511f;&#x5374;&#x4e0d;&#x8db3;&#x984d;"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -533.0956,
    x: "156.54721 165.43065 174.31409 183.19753"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -537.4134,
    x: 196.89839
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    y: -791.6863,
    x: "355.85783 363.54167 371.2255 378.90934"
  }, "&#x30fb;&#x3000;&#x3000;&#x30fb;"), /*#__PURE__*/React.createElement("tspan", {
    y: -783.05068,
    x: "355.85783 363.54167 371.2255 378.90934"
  }, "&#x30fb;&#x3000;&#x3000;&#x30fb;"), /*#__PURE__*/React.createElement("tspan", {
    y: -568.238,
    x: "341.2105 400.28004 410.36509 467.5136 477.59864 534.7472"
  }, "&#x5916;&#x5186;&#x5916;&#x5186;&#x5916;&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -156.60375,
    x: 534.387
  }, "&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -78.282878,
    x: "194.97743 198.81836"
  }, "27"), /*#__PURE__*/React.createElement("tspan", {
    y: -149.52727,
    x: "45.38268 72.996479 100.610279 128.10301 155.71683 183.20957"
  }, "&#x652f;&#x51fa;&#x3057;&#x305f;&#x91d1;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -125.77914,
    x: "45.38268 59.18958 72.996479 86.803379 100.61028 114.41718 128.22408 142.03098 155.71683 169.52373 183.20957"
  }, "&#x524d;&#x671f;&#x307e;&#x3067;&#x306b;&#x511f;&#x5374;&#x3057;&#x305f;&#x91d1;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -102.031009,
    x: "45.38268 79.8399 114.29712 148.75435 183.21157"
  }, "&#x5f53;&#x671f;&#x511f;&#x5374;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -78.282878,
    x: "45.38268 62.671319 79.8399 97.12854 114.29712 131.58576 148.75435 166.04299 183.21157"
  }, "&#x671f;&#x672b;&#x73fe;&#x5728;&#x306e;&#x5e33;&#x7c3f;&#x4fa1;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -149.52727,
    x: "194.97743 198.81836"
  }, "24"), /*#__PURE__*/React.createElement("tspan", {
    y: -125.77914,
    x: "194.97743 198.81836"
  }, "25"), /*#__PURE__*/React.createElement("tspan", {
    y: -102.031009,
    x: "194.97743 198.81836"
  }, "26"), /*#__PURE__*/React.createElement("tspan", {
    y: -173.27539,
    x: "45.38268 68.31413 91.24559 114.29711 137.22858 160.2801 183.21157 194.97743 198.81836"
  }, "&#x7e70;&#x5ef6;&#x8cc7;&#x7523;&#x306e;&#x7a2e;&#x985e;23"), /*#__PURE__*/React.createElement("tspan", {
    y: -561.16159,
    x: "58.829397 79.59878 100.36816 121.137538 141.78786 162.55725 183.20757 196.8934"
  }, "&#x7279;&#x5225;&#x511f;&#x5374;&#x9650;&#x5ea6;&#x984d;8"), /*#__PURE__*/React.createElement("tspan", {
    y: -305.3294,
    x: "58.829397 74.4372 89.92494 105.53274 121.020488 136.62828 152.11603 167.72383 183.21157"
  }, "&#x5dee;&#x5f15;&#x7fcc;&#x671f;&#x3078;&#x306e;&#x7e70;&#x8d8a;&#x984d;"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -294.5348,
    x: "58.829397 67.11354 71.55476 79.95896 88.2431 96.6473"
  }, "&#x25cf;a&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -294.5348,
    x: "104.93144 108.77335 112.61527 116.4572 121.01948 129.30362 133.14553 136.98744 140.82938"
  }, "(17)&#xff0d;(18)"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -294.5348,
    x: "145.2706 153.67479 162.07898 170.36312 178.7673 187.05146"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;a"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -299.9321,
    x: "194.97743 198.81836"
  }, "19"), /*#__PURE__*/React.createElement("tspan", {
    y: -489.9171,
    x: "194.97743 198.81836"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    y: -376.5738,
    x: "58.829397 71.315639 83.80187 96.28811 108.65329 121.13953 133.5047 145.99094 158.35611 170.84235 183.20752"
  }, "&#x5dee;&#x5f15;&#x5408;&#x8a08;&#x7fcc;&#x671f;&#x3078;&#x306e;&#x7e70;&#x8d8a;&#x984d;"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -365.7792,
    x: "58.829397 67.2336 75.637798 84.042"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -365.7792,
    x: "92.4462 96.28812 100.13003 103.971958 108.6543 117.058498 120.90041 124.742328 128.58426 133.26659 141.67079 145.5127 149.35462 153.19655"
  }, "(13)&#xff0b;(14)&#xff0d;(15)"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -365.7792,
    x: "157.75882 166.2831 174.80736 183.21155"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -711.56637,
    x: "45.38268 72.996479 100.610279 128.10301 155.71683 183.20957"
  }, "&#x652f;&#x51fa;&#x3057;&#x305f;&#x5e74;&#x6708;"), /*#__PURE__*/React.createElement("tspan", {
    y: -687.81826,
    x: "45.38268 72.996479 100.610279 128.10301 155.71683 183.20957"
  }, "&#x652f;&#x51fa;&#x3057;&#x305f;&#x91d1;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -664.07009,
    x: "45.38268 68.31413 91.24559 114.29711 137.22858 160.2801 183.21157"
  }, "&#x511f;&#x5374;&#x671f;&#x9593;&#x306e;&#x6708;&#x6570;"), /*#__PURE__*/React.createElement("tspan", {
    y: -644.6398,
    x: "45.38268 53.546758 61.71084 69.75486 77.918949 85.96296 94.12704 102.17106 110.33514 118.37916 126.54323 134.58725 142.75133 150.79534 158.95943 167.00344 175.16753 183.21154"
  }, "&#x5f53;&#x671f;&#x306e;&#x671f;&#x9593;&#x306e;&#x3046;&#x3061;&#x306b;&#x542b;&#x307e;&#x308c;&#x308b;&#x511f;&#x5374;&#x671f;&#x9593;&#x306e;"), /*#__PURE__*/React.createElement("tspan", {
    y: -636.00418,
    x: "45.38268 53.546758"
  }, "&#x6708;&#x6570;"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -636.00418,
    x: "61.59078 69.75486 77.918949 85.96296 94.12704 102.17106 110.33514 118.37916 126.54323 134.58725 142.75133 150.79534 158.95943 167.00344 175.16753 183.21154"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -463.53034,
    x: 47.06352
  }, "&#x5dee;"), /*#__PURE__*/React.createElement("tspan", {
    y: -444.95506,
    x: 47.06352
  }, "&#x5f15;"), /*#__PURE__*/React.createElement("tspan", {
    y: -471.5663,
    x: "58.829397 89.923938 121.01848 152.11302 183.20755"
  }, "&#x511f;&#x5374;&#x4e0d;&#x8db3;&#x984d;"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -460.77174,
    x: "58.829397 67.2336 75.637798 84.042 92.4462 100.97045"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;a"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -460.77174,
    x: "104.81137 108.65329 112.4952 116.33713 120.89941 129.42368 133.26558 137.1075 140.94944"
  }, "(10)&#xff0d;(11)"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -460.77174,
    x: "144.79036 149.35263 157.87689 166.2811 174.80536 183.20955"
  }, "a&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -447.81819,
    x: "58.829397 89.923938 121.01848 152.11302 183.20755"
  }, "&#x511f;&#x5374;&#x8d85;&#x904e;&#x984d;"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -437.0236,
    x: "58.829397 67.2336 75.637798 84.042 92.4462 100.97045"
  }, "&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;a"))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -437.0236,
    x: "104.81137 108.65329 112.4952 116.33713 120.89941 129.42368 133.26558 137.1075 140.94944"
  }, "(11)&#xff0d;(10)"))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -437.0236,
    x: "144.79036 149.35263 157.87689 166.2811 174.80536 183.20955"
  }, "a&#x25cf;&#x25cf;&#x25cf;&#x25cf;&#x25cf;"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -418.67274,
    x: "58.829397 76.597278 94.36516 112.13304 129.90091 147.6688 165.43668 183.20456"
  }, "&#x524d;&#x671f;&#x304b;&#x3089;&#x306e;&#x7e70;&#x8d8a;&#x984d;"), /*#__PURE__*/React.createElement("tspan", {
    y: -400.32194,
    x: "58.829397 70.115039 81.40068 92.68632 103.971958 115.25759 126.54323 137.82888 149.23456 160.5202 171.92589 183.21154"
  }, "&#x540c;&#x4e0a;&#x306e;&#x3046;&#x3061;&#x5f53;&#x671f;&#x640d;&#x91d1;&#x8a8d;&#x5bb9;&#x984d;"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0004999 0 842)",
    fontSize: 0.9004499,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -397.3234,
    x: 124.62226
  }, "a"))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -389.5273,
    x: 58.829397
  }, "&#x25cf;"))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -389.5273,
    x: "67.11354 70.95545 74.79737 78.63929 82.48022 87.042499 95.4467 99.28861 103.13053 106.972469 111.53474 119.93894 128.34314 136.74733 145.15154 153.55573 161.95992 170.3641 178.76831"
  }, "((12)&#x3068;(14)&#x306e;&#x3046;&#x3061;&#x5c11;&#x306a;&#x3044;&#x91d1;&#x984d;)"))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -389.5273,
    x: 183.20952
  }, "&#x25cf;"))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -418.67274,
    x: "194.97743 198.81836"
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    y: -394.92463,
    x: "194.97743 198.81836"
  }, "15"), /*#__PURE__*/React.createElement("tspan", {
    y: -224.72968,
    x: "194.97743 198.81836"
  }, "22"), /*#__PURE__*/React.createElement("tspan", {
    y: -352.5858,
    x: "58.829397 67.11354 75.397678 83.681819 91.96596 100.25009 108.53423 116.81837 125.10251 133.38665 141.67079 149.95493 158.23906 166.52321 174.9274 183.21154"
  }, "&#x7fcc;&#x671f;&#x306b;&#x7e70;&#x308a;&#x8d8a;&#x3059;&#x3079;&#x304d;&#x7279;&#x5225;&#x511f;&#x5374;&#x4e0d;&#x8db3;&#x984d;"))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0005 0 842)",
    fontSize: 4.702349,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -342.1509,
    x: 58.82939
  }, "5"))), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.0034997,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -342.15098,
    x: "61.2306 64.8324 68.4342 72.035999 75.637798 79.59978 87.16355 90.76535 94.36715 97.968959 101.93093 109.49471 113.09651 116.69831 120.30011 124.26209 131.82587 139.38965 146.95343 154.5172 162.08098 169.64476 177.32759 184.89138"
  }, "((12)&#x3068;((8)&#xff0b;(9))&#x306e;&#x3046;&#x3061;&#x5c11;&#x306a;&#x3044;&#x91d1;&#x984d;)"))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.9995004 0 -0 1.0005 0 842)",
    fontSize: 4.702349,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -342.1509,
    x: 188.49317
  }, "a"))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -276.18397,
    x: "194.97743 198.81836"
  }, "20"))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "410.36509 418.52915 426.69325"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 434.85734
  }, "&#x6761;"))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "443.0214 451.1855 459.34959"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 467.51365
  }, "&#x9805;"))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 410.36509
  }, "a"))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: "414.20597 467.5126"
  }, "()"))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 471.35353
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "206.74332 214.9074 223.07147"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 231.23557
  }, "&#x6761;"))), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "239.39965 247.56374 255.72782"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 263.89189
  }, "&#x9805;"))), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 206.74332
  }, "a"))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: "210.58423 263.89088"
  }, "()"))), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 267.73179
  }, "a"))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -568.238,
    x: "206.74332 263.89189 273.9769 331.12547"
  }, "&#x5916;&#x5186;&#x5916;&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -584.90969,
    x: 196.89839
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    y: -466.169,
    x: "194.97743 198.81836"
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    y: -442.42088,
    x: "194.97743 198.81836"
  }, "13"), /*#__PURE__*/React.createElement("tspan", {
    y: -671.14657,
    x: 263.53169
  }, "&#x6708;"), /*#__PURE__*/React.createElement("tspan", {
    y: -371.17649,
    x: "194.97743 198.81836"
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    y: -347.42835,
    x: "194.97743 198.81836"
  }, "17"), /*#__PURE__*/React.createElement("tspan", {
    y: -623.65029,
    x: "330.7653 399.91987 467.1534 534.387"
  }, "&#x5186;&#x5186;&#x5186;&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -694.8947,
    x: "399.91987 467.1534"
  }, "&#x5186;&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -671.14657,
    x: "330.7653 399.91987 467.1534"
  }, "&#x6708;&#x6708;&#x6708;"), /*#__PURE__*/React.createElement("tspan", {
    y: -694.8947,
    x: "534.387 330.76527"
  }, "&#x5186;&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -735.3145,
    x: "45.38268 68.31413 91.24559 114.29711 137.22858 160.2801 183.21157"
  }, "&#x7e70;&#x5ef6;&#x8cc7;&#x7523;&#x306e;&#x7a2e;&#x985e;"), /*#__PURE__*/React.createElement("tspan", {
    y: -694.8947,
    x: 263.53169
  }, "&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -623.7081,
    x: 263.53169
  }, "&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -711.56637,
    x: 196.89839
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    y: -687.8375,
    x: 196.89839
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    y: -664.10867,
    x: 196.89839
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    y: -640.37979,
    x: 196.89839
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    y: -612.6959,
    x: 196.89839
  }, "6"))), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -759.0626,
    x: "140.47019 157.51873 169.52472 181.53072 193.53672 205.54271 216.46817 228.47417 238.31909 250.32509 262.33113 274.3371 286.3431 298.22804 310.23405 322.119 334.12498 346.00993 358.0159 369.90086 381.4266 393.31153 405.07743 415.8828 427.88883 439.77375"
  }, "&#x2160;&#x5747;&#x7b49;&#x511f;&#x5374;&#x3092;&#x884c;&#x3046;&#x7e70;&#x5ef6;&#x8cc7;&#x7523;&#x306e;&#x511f;&#x5374;&#x984d;&#x306e;&#x8a08;&#x7b97;&#x306b;&#x95a2;&#x3059;&#x308b;&#x660e;&#x7d30;&#x66f8;"))), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -156.60375,
    x: "263.53169 330.76527 399.91984"
  }, "&#x5186;&#x5186;&#x5186;"), /*#__PURE__*/React.createElement("tspan", {
    y: -735.3145,
    x: 196.89839
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    y: -671.14657,
    x: 534.387
  }, "&#x6708;"), /*#__PURE__*/React.createElement("tspan", {
    y: -796.00418,
    x: "297.7488 305.43263 313.11647 320.80033"
  }, "&#x4e8b;&#x696d;&#x5e74;&#x5ea6;"), /*#__PURE__*/React.createElement("tspan", {
    y: -787.3685,
    x: "297.7488 305.43263 313.11647 320.80033"
  }, "&#x53c8;&#x306f;&#x9023;&#x7d50;"), /*#__PURE__*/React.createElement("tspan", {
    y: -778.7328,
    x: "297.7488 305.43263 313.11647 320.80033"
  }, "&#x4e8b;&#x696d;&#x5e74;&#x5ea6;"))), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -197.02353,
    x: "140.47019 156.19805 166.88338 177.56871 188.25405 198.93938 209.62471 220.31005 230.87433 240.11896 250.80429 260.4091 271.09443 281.77976 292.4651 303.15043 313.83576 324.5211 335.20643 345.89176 356.5771 367.26243 377.8267 388.0318 398.59608 409.04029 418.52503 429.21037 439.77464"
  }, "&#x2161;&#x4e00;&#x6642;&#x511f;&#x5374;&#x304c;&#x8a8d;&#x3081;&#x3089;&#x308c;&#x308b;&#x7e70;&#x5ef6;&#x8cc7;&#x7523;&#x306e;&#x511f;&#x5374;&#x984d;&#x306e;&#x8a08;&#x7b97;&#x306b;&#x95a2;&#x3059;&#x308b;&#x660e;&#x7d30;&#x66f8;"))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -156.60375,
    x: 467.15345
  }, "&#x5186;"))), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "477.59864 485.76274 493.92683"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 502.0909
  }, "&#x6761;"))), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "510.25498 518.419 526.58309"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 534.74716
  }, "&#x9805;"))), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 477.59864
  }, "a"))), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: "481.43955 534.7462"
  }, "()"))), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 538.58718
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "273.9769 282.141 290.30509"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 298.46916
  }, "&#x6761;"))), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "306.63325 314.79734 322.9614"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 331.1255
  }, "&#x9805;"))), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 273.9769
  }, "a"))), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: "277.8178 331.12446"
  }, "()"))), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 334.96537
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "341.2105 349.61473 358.0189"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 366.4231
  }, "&#x6761;"))), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: "374.8273 383.35154 391.8758"
  }, "&#x25cf;&#x25cf;&#x25cf;"))), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -589.2275,
    x: 400.27998
  }, "&#x9805;"))), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 341.2105
  }, "a"))), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: "345.05143 400.27903"
  }, "()"))), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    xmlSpace: "preserve",
    transform: "matrix(.99950036 0 -0 1.0004999 0 842)",
    fontSize: 7.5037496,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -580.59188,
    x: 404.11994
  }, "a"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M408.72 774.082H408.84V806.24197H408.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.36 504.322H57.48V631.042H57.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M43.56 210.922H44.4V774.082H43.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M191.76 211.762H191.87999V749.84207H191.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M205.2 211.762H205.31999V749.84207H205.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M272.4 211.762H272.52V749.84207H272.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M339.6 211.762H339.72V749.84207H339.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M408.72 211.762H408.84V749.84207H408.72Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M475.92 211.762H476.04V749.84207H475.92Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M542.76 210.922H543.60006V806.242H542.76Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M292.2 773.242H293.04V807.08206H292.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M332.88 774.082H333V806.24197H332.88Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M408.72 69.202H408.84V187.162H408.72Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M442.32 774.082H442.44V806.24197H442.32Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M542.76 68.362H543.60006V187.162H542.76Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M43.56 68.362H44.4V188.002H43.56Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M191.76 69.202H191.87999V187.162H191.76Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M205.2 69.202H205.31999V187.162H205.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M272.4 69.202H272.52V187.162H272.4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M339.6 69.202H339.72V187.162H339.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M475.92 69.202H476.04V187.162H475.92Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.36 242.962H57.48V480.562H57.36Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M77.52 242.962H77.64V290.482H77.52Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M293.04 806.242H543.6V807.08206H293.04Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 773.242H543.60006V774.08206H44.4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 749.842H542.76V749.962H44.4Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 726.082H542.76V726.20199H44.4Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 702.322H542.76V702.442H44.4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 678.562H542.76V678.682H44.4Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 654.802H542.76V654.922H44.4Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 631.042H542.76V631.162H44.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 599.362H542.76V599.482H57.48Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 575.602H542.76V575.722H57.48Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 551.842H542.76V551.962H57.48Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 528.082H542.76V528.20199H57.48Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 504.322H542.76V504.442H44.4Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 480.562H542.76V480.682H44.4Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 456.802H542.76V456.922H57.48Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 433.042H542.76V433.162H44.4Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 409.282H542.76V409.402H57.48Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 385.522H542.76V385.642H57.48Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 361.762H542.76V361.882H44.4Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 338.002H542.76V338.122H57.48Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 314.242H542.76V314.362H57.48Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M57.48 290.482H542.76V290.602H57.48Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M77.64 266.722H542.76V266.84199H77.64Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 242.962H542.76V243.082H44.4Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 210.922H543.60006V211.762H44.4Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 187.162H543.60006V188.002H44.4Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 163.762H542.76V163.88199H44.4Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 140.002H542.76V140.122H44.4Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 116.242H542.76V116.362H44.4Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 92.482H542.76V92.602008H44.4Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M44.4 68.362H543.60006V69.201999H44.4Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,43.8,68.15802)",
    d: "M0 0V0L-.36 .36Z"
  })), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 842)",
    fontSize: 7.5,
    fontFamily: "MS"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -610.282,
    x: "129.12 132.95999 136.79999"
  }, "(5)"), /*#__PURE__*/React.createElement("tspan", {
    y: -601.642,
    x: "129.12 132.95999 136.79999"
  }, "(4)"))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,842)",
    d: "M128.04 608.842H141.48V609.20199H128.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b5f4fbb3f8e06df9247dbff04158aac2.svg";
export { ForwardRef as ReactComponent };